module.exports = __webpack_public_path__ + "img/fi-xlsx.24521f36.svg";